import * as constants from '../constants';

export const isAvailableToSell = (color) => color.ats > 0;

const getColorSwatchStyle = (color) => {
    const css = {};

    if (color && color.custom && color.custom.hex) {
        css.backgroundColor = color.custom.hex.startsWith('#') ? color.custom.hex : `#${color.custom.hex}`;
    }

    if (color && color.custom && color.custom.image) {
        css.backgroundImage = `url(${color.custom.image})`;
    }

    return css;
};

export const getSupportedPrintingModes = (selectedComponent) => {
    const supportsEtching = selectedComponent.custom['v-supports-etching'] === 'true';
    const supportsPrinting = selectedComponent.custom['v-supports-printing'] === 'true';

    return {
        supportsEtching,
        supportsPrinting,
    };
};

export const getAvailableColorways = ({ viewController, placement, productData }) => {
    if (viewController == null) {
        return [];
    }

    let usePlacement = viewController.findPlacement(constants.PLACEMENT_PRODUCT);

    if (placement) {
        usePlacement = placement;
    }

    const selected = viewController.selectedAtPlacement(usePlacement.code);

    const colors = usePlacement.components.map((c) => {
        let ats = 0;

        const product = productData.find((p) => p.productId === c.placementIndependentCode);

        if (product && product.online) {
            ats = product.ats;
        }

        if (!viewController.isAvailable(c)) {
            ats = 0;
        }

        const color = {
            option: c,
            selected: selected.code === c.code,
            style: getColorSwatchStyle(c),
            name: viewController.componentNames(c).join(''),
            ats,
        };

        return color;
    });

    return colors;
};

export function getAvailablePrintingMethods({
    viewController,
    availableColors,
    selectedPersonalizationMethod,
    $t,
}) {
    const methods = [];

    const selectedComponent = viewController.selectedAtPlacement(constants.PLACEMENT_PRODUCT);
    const { supportsEtching, supportsPrinting } = getSupportedPrintingModes(selectedComponent);

    availableColors.forEach((color) => {
        if (color.option.custom['v-supports-etching'] === 'true') {
            if (methods.find((m) => m.type === 'etching') == null) {
                const notes = viewController.blueprint.custom['v-etching-description'];

                methods.push({
                    type: 'etching',
                    selected: selectedPersonalizationMethod === 'etching',
                    name: $t('PRINTING_ETCHING'),
                    notes,
                    available: supportsEtching,
                });
            }
        }

        if (color.option.custom['v-supports-printing'] === 'true') {
            if (methods.find((m) => m.type === 'printing') == null) {
                const notes = viewController.blueprint.custom['v-printing-description'];

                methods.push({
                    type: 'printing',
                    selected: selectedPersonalizationMethod === 'printing',
                    name: $t('PRINTING_PRINTING'),
                    notes,
                    available: supportsPrinting,
                });
            }
        }
    });

    return methods;
}
